import React, { useEffect, useRef, useState } from 'react'
import { useField, useFormikContext } from 'formik'

// Campo de texto que guarda o valor localmente enquanto o usuário digita e só
// repassa ao Formik após uma pausa curta ou no blur. Em listas grandes isso
// evita re-renderizar o formulário inteiro a cada tecla.
const CampoTexto = ({ label, tamanho, obrigatorio, atraso, ...props }) => {
    const [field, meta, helpers] = useField(props.name)
    const { submitCount } = useFormikContext()
    const [valor, setValor] = useState(field.value || '')
    const timer = useRef(null)
    const ultimoEnviado = useRef(field.value || '')

    useEffect(() => {
        const externo = field.value || ''

        if (externo !== ultimoEnviado.current) {
            ultimoEnviado.current = externo
            setValor(externo)
        }
    }, [field.value])

    useEffect(() => () => clearTimeout(timer.current), [])

    const enviar = novoValor => {
        if (novoValor !== ultimoEnviado.current) {
            ultimoEnviado.current = novoValor
            helpers.setValue(novoValor)
        }
    }

    const onChange = e => {
        const novoValor = e.target.value
        setValor(novoValor)
        clearTimeout(timer.current)
        timer.current = setTimeout(() => enviar(novoValor), atraso || 400)
    }

    const onBlur = () => {
        clearTimeout(timer.current)
        enviar(valor)
        helpers.setTouched(true)
    }

    const erro = meta.error && (meta.touched || submitCount > 0) ? meta.error : null

    return (
        <div className={'form-group ' + (tamanho || 'col-12')}>
            {label ? <label htmlFor={props.name}>{label}{obrigatorio ? ' *' : ''}</label> : null}
            <input type='text' {...props} id={props.name} className={'form-control' + (erro ? ' is-invalid' : '')} value={valor} onChange={onChange} onBlur={onBlur} />
            {erro ? <small className='fpa-erro'>{erro}</small> : null}
        </div>
    )
}

export default CampoTexto
